import React from 'react';
import { shape, string, arrayOf } from 'prop-types';
import locationShape from 'propTypes/locationShape';

import LocationMarker from './LocationMarker';

/**
 * isLocationActive checks if the location is present in one of the segments in the selectedSegments array.
 * @param {any} { location, segments, selectedSegments, hoveredId }
 * @returns
 */
function isLocationActive({ location, segments, selectedSegments, hoveredId }) {
  // checks if the object.id matches the hovered state or is present in one of the currently selected segments for the newly created route
  const idMatchesActiveStates = ({ id }) =>
    id === hoveredId ||
    segments.reduce((acc, segment) => {
      if (selectedSegments.includes(segment.id)) {
        return acc || segment.from.id === location.id || segment.to.id === location.id;
      }

      return acc;
    }, false);

  if (idMatchesActiveStates(location)) return true;

  // check whether id a segment which is connected to the location
  const activeSegment = segments.find(idMatchesActiveStates);

  return (
    activeSegment && (activeSegment.from.id === location.id || activeSegment.to.id === location.id)
  );
}

function LocationMarkerGroup({ locations, segments, selectedSegments, currentHover }) {
  // eslint-disable-next-line global-require
  const { FeatureGroup } = require('react-leaflet');

  const hoveredId = currentHover && currentHover.id;

  return (
    <FeatureGroup>
      {locations.map(location => {
        const { id, trackingDevice, lat, lng, name } = location;

        const isActive = isLocationActive({
          location,
          segments,
          selectedSegments,
          hoveredId,
        });

        return (
          <LocationMarker
            key={`${id}`}
            trackingDevice={trackingDevice}
            position={[lat, lng]}
            name={name}
            id={id}
            isActive={isActive}
            isFaded={!isActive}
          />
        );
      })}
    </FeatureGroup>
  );
}

LocationMarkerGroup.propTypes = {
  locations: arrayOf(locationShape).isRequired,
  segments: arrayOf(
    shape({
      id: string.isRequired,
      from: shape({ name: string }).isRequired,
      to: shape({ name: string }).isRequired,
    })
  ).isRequired,
  selectedSegments: arrayOf(string).isRequired,
  currentHover: shape({
    id: string.isRequired,
  }),
};

export default LocationMarkerGroup;



// WEBPACK FOOTER //
// ./src/components/Map/CreateRoute/LocationMarkerGroup/index.js